import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import LoginForm from 'components/LoginForm/LoginForm';
import FormContainer from 'uI/FormContainer/FormContainer';
import RegisterForm from 'components/RegisterForm/RegisterForm';
import MyDegree from 'uI/MyDegree/MyDegree';

import classes from './CheckUser.module.css';

const CheckUser = () => {
  const [userName, setUserName] = useState('');
  const [userLastName, setUserLastName] = useState('');

  const [showPage, setShowPage] = useState('login');
  const { t } = useTranslation(['login']);

  const changePageHandler = page => {
    setShowPage(page);
  };

  const changeNameHandler = name => {
    setUserName(name);
  };

  const changeLastNameHandler = lastName => {
    setUserLastName(lastName);
  };

  return (
    <div className={classes.formSectionUDC}>
      {showPage === 'login' && (
        <aside className={classes.infoContainer}>
          <figure className={classes.udcAvatarLogin}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/logoUDC_Registro.png"
              alt=""
            />
          </figure>
          <p className={classes.titlePreRegisterLogin}>
            Bienvenida/o a la Universidad de las Ciencias
          </p>
          <p className={classes.subtitlePreRegisterLogin}>
            Comienza aquí tu proceso de admisión e inscripción, o
            continúa si ya lo habías comenzado.
          </p>
        </aside>
      )}

      {showPage === 'login' ? (
        <FormContainer title={t('principal_text')} udc>
          <LoginForm
            prevUrl="preregister"
            udc
            changePage={changePageHandler}
          />
        </FormContainer>
      ) : (
        <FormContainer udc>
          <RegisterForm
            prevUrl="preregister"
            udc
            changeName={changeNameHandler}
            changeLastName={changeLastNameHandler}
          />
        </FormContainer>
      )}
      {showPage === 'register' && (
        <MyDegree
          demoProfile
          name={userName}
          lastName={userLastName}
        />
      )}
    </div>
  );
};

CheckUser.propTypes = {
  // eslint-disable-next-line react/require-default-props
  nextStep: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  changePage: PropTypes.func
};

export default CheckUser;
